
import { OnInit } from '@angular/core';
import { Component, ViewChild } from '@angular/core';
import { ConfigService } from '@core/services/config.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

declare const google: any;
@Component({
  selector: 'app-maps',
  templateUrl: './maps.component.html',
  styleUrls: ['./maps.component.scss']
})
export class MapsComponent implements OnInit {

  @ViewChild('mapElement', { static: true }) mapElement: any;
  receivedData: any;
  geocoder?: any = null;
  title = 'AppComponent'
  map: any;
  marker: any = null;
  streetViewLink = '';
  count: number = 0;
  formattedLocation: any;
  userLocationData:any;
  searchLocationMarker: any;
  lat:number;
  lng:number;

  markerPosition: {
    lat: number
    lng: number
  } | undefined;

  clickedLocation: {
    lat:number,
    lng:number
  };
  constructor(
    public readonly ref: DynamicDialogRef,
    public readonly configService: ConfigService,
    private readonly config: DynamicDialogConfig) { }

  ngOnInit(): void {
    this.receivedData = this.config.data;
    this.openMap()
  }

  openMap(): void {
    if (this.receivedData) {
      this.markerPosition = {
        lat: this.receivedData.latitude,
        lng: this.receivedData.longitude
      }

      this.map = new google.maps.Map(this.mapElement.nativeElement, {
        center: { lat: this.receivedData.latitude, lng: this.receivedData.longitude },
        zoom: 15,
        scrollwheel: true,
        gestureHandling: 'greedy'
      })
      this.searchLocationMarker = new google.maps.Marker({
        position: this.markerPosition,
        map: this.map,
        title: 'Your Location'
      })

    }
    else {
      this.getCurrentLocation();
      if(!(this.lat && this.lng)){
        this.lat= 37.0902,
        this.lng= -95.7129
        this.map = new google.maps.Map(this.mapElement.nativeElement, {
          center: { lat: this.lat, lng: this.lng },
          zoom: 6,
          scrollwheel: true,
          gestureHandling: 'greedy'
        })
      }
      else{
      this.map = new google.maps.Map(this.mapElement.nativeElement, {
        center: { lat: this.lat, lng: this.lng },
        zoom: 10,
        scrollwheel: true,
        gestureHandling: 'greedy'
      })
      }
    }
    this.geocoder = new google.maps.Geocoder();
    google.maps.event.addListener(this.map, 'click', (event: any) => {
      this.handleMapClick(event.latLng.lat(),event.latLng.lng());
    });
  }
  getCurrentLocation(): void {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const userLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        this.lat = userLocation.lat
        this.lng = userLocation.lng
        this.clickedLocation = {
          lat:userLocation.lat,
          lng:userLocation.lng
        }
        this.marker = new google.maps.Marker({
          position: this.clickedLocation,
          map: this.map,
          title: 'Your Location'
        });
        this.map.setCenter(this.clickedLocation);
        this.generateFormatedLoc();
      }, );
    }
  }
  selectLocation(): void {
    if (this.formattedLocation) {
      this.ref.close(this.formattedLocation);
    }
    else {
      this.ref.close(this.receivedData);

    }
  }
  cancel() {
    if (this.receivedData) {
      this.ref.close(this.receivedData);
    }
    else {
      this.ref.close();
    }
  }

  handleMapClick(lat: number, lng: number): void {
  this.searchLocationMarker?.setMap(null);
  this.clickedLocation = { lat, lng };
  this.streetViewLink = `${this.configService.get('mapUrls').streetView}${lat},${lng},16z?hl=en&q=${lat},${lng}`;
   this.marker?.setMap(null);
  this.marker = new google.maps.Marker({
    position: this.clickedLocation,
    map: this.map,
    title: 'Your Location'
  });

  this.generateFormatedLoc();
}

  generateFormatedLoc(){
    let location: any = {
      streetAddress: '', // Initialize the streetAddress property
    };
    this.geocoder?.geocode({ location: this.clickedLocation }, (results, status) => {
      if (status === 'OK') {
        if (results && results[0]) {
          const addressComponents = results[0].address_components;
          //long_name
          let locAddress = results[0].formatted_address;
          // Extract city, state, and zip code from address components
          for (const component of addressComponents) {
            if (component.types.includes('route') || component.types.includes('street_number')) {
              location.streetAddress += component.long_name + ' ';
            } else if (component.types.includes('administrative_area_level_1')) {
              location.state = component.long_name;
            } else if (component.types.includes('country')) {
              location.country = component.long_name;
            }
          }
          location.latitude = this.clickedLocation.lat;
          location.longitude = this.clickedLocation.lng;
          location.streetViewLink = this.streetViewLink
          // Add address and streetView properties (You need to set streetView accordingly)
          location.address = location.streetAddress; // You can modify this as needed
          // Create the final formatted location object
          this.formattedLocation = {
            country: location.country || '',
            state: location.state || '',
            latitude: location.latitude || '',
            longitude: location.longitude || '',
            address: locAddress || '',
            streetView: location.streetViewLink || '',
          };
        }
      }
    });
  }
}
